export var FlowEvaluators;
(function (FlowEvaluators) {
    FlowEvaluators["cSharpV1"] = "CSharpVersion1";
    FlowEvaluators["jsV1"] = "JavaScriptVersion1";
})(FlowEvaluators || (FlowEvaluators = {}));
